import distance from '@turf/distance';
import { LaneInput } from '@kinetic-ui/data-layer';
import { RecursivePartial } from 'types';

export const getLaneAnchorPoint = (
  lane: RecursivePartial<LaneInput>,
  intersectionCoordinates?: number[]
): { anchorCoordinates: [number, number]; approaching: boolean } => {
  if (
    !lane ||
    !lane.geometry ||
    lane.geometry.coordinates.length === 0 ||
    !intersectionCoordinates
  ) {
    // just returning a valid value here to prevent errors - nothing is rendered when there are no points
    return { anchorCoordinates: [0, 0], approaching: true };
  }

  if (lane.geometry.coordinates.length === 1) {
    // approaching doesn't matter here, as it's one point, but is required in return value
    return { anchorCoordinates: lane.geometry.coordinates[0], approaching: true };
  }

  const firstPoint = lane.geometry.coordinates[0];
  const firstPointDistance = distance(firstPoint, intersectionCoordinates);

  const lastPoint = lane.geometry.coordinates[lane.geometry.coordinates.length - 1];
  const lastPointDistance = distance(lastPoint, intersectionCoordinates);

  // when approaching is true, the first coordinate is the furthest away and they approach the center
  // when approaching is false, the first coordinate is the closest and they get further away
  return lastPointDistance < firstPointDistance
    ? { anchorCoordinates: lastPoint, approaching: true }
    : { anchorCoordinates: firstPoint, approaching: false };
};
